<script>
export default {
  name: "nav",
  data() {
    return {
      permissionList: [],
      sidebar: {
        _name: "CSidebarNav",
        _children: [
          {
            id: 1,
            _name: "CSidebarNavItem",
            name: `FLOW BUILDER`,
            to: "/flow-builder",
            icon: "cil-settings",
          },

          {
            id: 2,
            _name: "CSidebarNavItem",
            name: `CHAT ANALYSIS`,
            to: "/chat-analysis",
            icon: "cil-bar-chart",
          },
          {
            id: 3,
            _name: "CSidebarNavItem",
            name: `MESSAGE LOG`,
            to: "/message-log",
            icon: "cil-list",
          },
          {
            id: 4,
            _name: "CSidebarNavItem",
            name: `IMAGE MAP`,
            to: "/image-map",
            icon: "cil-image",
          },
          {
            id: 4,
            _name: "CSidebarNavItem",
            name: `SENTIMENT TRAINING`,
            to: "/sentiment-training",
            icon: "cil-comment-bubble",
          },
          {
            id: 11,
            _name: "CSidebarNavItem",
            name: `FLOW WAY TRAINING`,
            to: "/flowway-training",
            icon: "cil-comment-bubble",
          },
          {
            id: 5,
            _name: "CSidebarNavItem",
            name: `SETTING TIME`,
            to: "/setting-time",
            icon: "cil-settings",
          },
          // {
          //   id: 6,
          //   _name: "CSidebarNavItem",
          //   name: `EMAIL CONFIG`,
          //   to: "/email-config",
          //   icon: "cil-settings",
          // },
          // {
          //   id: 5,
          //   _name: "CSidebarNavItem",
          //   name: `SETTING WIDGET`,
          //   to: "/setting-widget",
          //   icon: "cil-settings",
          // },
          // {
          //   id: 7,
          //   _name: "CSidebarNavItem",
          //   name: `USER`,
          //   to: "/user",
          //   icon: "cil-user",
          // },
          {
            id: 8,
            _name: "CSidebarNavItem",
            name: `LIVE`,
            to: "/live",
            icon: "cil-user",
          },
          {
            _name: "CSidebarNavDropdown",
            name: `SETTING`,
            icon: "cil-settings",
            _children: [
              {
                id: 9,
                _name: "CSidebarNavItem",
                name: `SETTING`,
                to: "/setting",
                icon: "cil-settings",
              },
              {
                id: 11,
                _name: "CSidebarNavItem",
                name: `SETTING BRAND`,
                to: "/setting-brand",
                icon: "cil-settings",
              },
              {
                id: 20,
                _name: "CSidebarNavItem",
                name: `SETTING CONFIG`,
                to: "/setting-config",
                icon: "cil-settings",
              }
            ]
          },
          {
            id: 12,
            _name: "CSidebarNavItem",
            name: `API TRIGGER`,
            to: "/api-trigger",
            icon: "cil-settings",
          },
          {
            id: 13,
            _name: "CSidebarNavItem",
            name: `WEBHOOK`,
            to: "/webhook",
            icon: "cil-settings",
          },
          {
            id: 15,
            _name: "CSidebarNavItem",
            name: `VARIABLE`,
            to: "/variable",
            icon: "cil-settings",
          },
          {
            id: 14,
            _name: "CSidebarNavItem",
            name: `CUSTOMER`,
            to: "/customer",
            icon: "cil-user",
          },
          {
            id: 10,
            _name: "CSidebarNavItem",
            name: `CHAT`,
            to: "/chat",
            icon: "cil-comment-bubble",
          },
        ],
      },
    };
  },
  computed: {
    sidebarItems() {
      return [this.sidebar];
    },
  },
  created: async function() {},
  methods: {},
};
</script>
